// import Swiper from "swiper/dist/js/swiper.js";
import Swiper from 'swiper/bundle';
import { wait } from "./../../helpers/global";

export default class CarouselImg {
  constructor() {
    this.carouselWrapper = document.querySelectorAll(".jsCarouselImgWrapper");
    if (this.carouselWrapper) this.init();
  }

  setCarousel(i) {
    this.carousel = i.querySelector(".jsCarouselImg");
    this.carouselContent = i.querySelector(".jsCarouselImgContent");
    this.carouselPagination = i.querySelector(".jsCarouselImgPagination");

    // helpers
    this._content = {};
    this._details = {};

    this._config = {
      speed: 700,
      effect: "fade",
      preloadImages: true,
      autoplay:true,
      autoplayTimeout:1000,
      autoplayHoverPause:true,
      updateOnImagesReady: true,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.carouselPagination,
        clickable: true,
        renderBullet: (index, className) =>
          '<span class="carousel-bullet__item ' + className + '"></span>'
      }
    };

    this._configTxt = {
      autoHeight: true,
      speed: 700,
      spaceBetween: 30,
      pagination: {
        el: this.carouselPagination,
        clickable: true,
        renderBullet: (index, className) =>
          '<span class="carousel-bullet__item ' + className + '"></span>'
      },
    };

    this._content = new Swiper(this.carousel, this._config);
    this._details = new Swiper(this.carouselContent, this._configTxt);

    if ( typeof this._content.controller != 'undefined' ){
      this._content.controller.control = this._details;
    }

    if ( typeof this._details.controller != 'undefined' )
    {
      this._details.controller.control = this._content;
    }
  }

  init() {
    for (let i = 0; i < this.carouselWrapper.length; i++) {
      const el = this.carouselWrapper[i];
      this.setCarousel(el);
    }
  }
}
